import React from 'react';
import './styles.css';

const Header = () => (
  <header className='home-header'>
    <h2>ErrorByNight</h2>
    <h1>
      <span>“</span>The Idea Brew<span>”</span>
    </h1>
    <p>
    Brought to you by Chirag Ferwani
    </p>
  </header>
);

export default Header;
